import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "music-indicator",
  "use": "music-indicator-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"music-indicator\"><defs><style>#music-indicator .a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}</style></defs><path class=\"a\" d=\"M4.3 17.017A9.752 9.752 0 014.914 1.5M7.555 14.573a6.751 6.751 0 01-.214-9.965M23.149 7.066a6.75 6.75 0 10-10.564 6.66A3.83 3.83 0 0114.3 17.36a4.494 4.494 0 003.643 5.069A4.5 4.5 0 0023.25 18M20.058 8.42a2.75 2.75 0 10-5.458.68\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol